<template>
    
    <div style="z-index: 200; position: fixed;" v-if="isMobile()">

        <img 
            :src="btn.music"
            id="music-btn"
            :class="generateClass"
            @click="autoplayMusic"
        />

        <img 
            :src="btn.puzzleRule"
            id="puzzle-rule-btn"
            class="btn"
            @click="openRuleDialog"
        />

        <audio webkit-playsinline="true" playsinline="true" loop>
            <source src="https://img.21jingji.com//uploadfile/cover/20220606/1e358b732a4cd3eac49ee3c7d057a96f.mp3" type="audio/mpeg" />
            <embed src="https://img.21jingji.com//uploadfile/cover/20220606/1e358b732a4cd3eac49ee3c7d057a96f.mp3" >
            Your browser does not support this audio format.
        </audio>
    </div>
</template>

<script>

    import { toRefs, reactive, getCurrentInstance, computed } from "vue";

    import HelperMixin from "@/mixins/helper";

    import musicBtn from "@/assets/home/music.png";
    import puzzleRuleBtn from "@/assets/home/puzzle_rule_btn.png";

    export default {
        name: "HomeTopNavbar",
        mixins: [ HelperMixin ],
        setup() {

            const _this = getCurrentInstance().appContext.config.globalProperties;

            const state = reactive({
                btn: {
                    music: musicBtn,
                    puzzleRule: puzzleRuleBtn
                },
                isPlaying: false
            });

            const autoplayMusic = () => {

                state.isPlaying = !state.isPlaying;

                const audio = document.querySelector("audio");

                if (state.isPlaying) {
                    audio.play();
                } else {
                    audio.pause();
                }
            };

            const openRuleDialog = () => {

                _this.$bus.$emit(_this.$constants.EVENT.RULE_DIALOG, {
                    type: _this.$constants.ENUM.RULE_DIALOG.OPEN
                });
            }

            const generateClass = computed(() => {

                const playingClass = state.isPlaying? "music-btn-playing" : "";

                return `btn ${playingClass}`;
            });

            return {
                ...toRefs(state),
                autoplayMusic,
                openRuleDialog,
                generateClass
            };
        },
        mounted() {
            
            document.addEventListener("touchstart", this.autoplayMusic, false);

            document.addEventListener("touchend", () => {
                document.removeEventListener("touchstart", this.autoplayMusic, false);
            });
        }
    };
</script>

<style lang="scss" scoped>

    #music-btn {
        position: fixed;
        left: 13px;
        top: 20px;
        height: 30px;
        width: auto;
    }

    .music-btn-playing {
        animation: rotate360 7s linear 0.2s infinite;
    }

    @keyframes rotate360 {

        100% {
            transform: rotate(360deg);
        }
    }

    #puzzle-rule-btn {
        position: fixed;
        right: 0;
    }

    @media screen and (min-height: 800px) {
        
        #puzzle-rule-btn {
            top: 4%;
            height: 40px;
        }
    }

    @media screen and (max-height: 800px) {
        
        #puzzle-rule-btn {
            top: 3%;
            height: 30px;
        }
    }
</style>